import React, { useState } from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { LayoutDashboard, Package, FileText, Settings, LogOut, FlaskConical, FolderTree, ClipboardCheck, Scale, Search, BarChart3, Megaphone, Factory, Target, Tag, Truck, LayoutTemplate, Shuffle, History, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/yonetim", icon: LayoutDashboard, label: "Panel", end: true },
  { to: "/yonetim/urunler", icon: Package, label: "Ürünler" },
  { to: "/yonetim/kategoriler", icon: FolderTree, label: "Kategoriler" },
  { to: "/yonetim/sektorler", icon: Factory, label: "Sektörler" },
  { to: "/yonetim/kullanim-alanlari", icon: Target, label: "Kullanım Alanları" },
  { to: "/yonetim/markalar", icon: Tag, label: "Markalar" },
  { to: "/yonetim/tedarikciler", icon: Truck, label: "Tedarikçiler" },
  { to: "/yonetim/teklifler", icon: FileText, label: "Teklif Talepleri" },
  { to: "/yonetim/kontrol", icon: ClipboardCheck, label: "Kontrol Bekleyenler" },
  { to: "/yonetim/yasal-metinler", icon: Scale, label: "Yasal Metinler" },
  { to: "/yonetim/icerik", icon: LayoutTemplate, label: "Site İçerikleri" },
  { to: "/yonetim/yonlendirmeler", icon: Shuffle, label: "Yönlendirmeler" },
  { to: "/yonetim/degisiklik-gecmisi", icon: History, label: "Değişiklik Geçmişi" },
  { to: "/yonetim/seo", icon: Search, label: "SEO" },
  { to: "/yonetim/search-console", icon: BarChart3, label: "Search Console" },
  { to: "/yonetim/google-ads", icon: Megaphone, label: "Google Ads" },
  { to: "/yonetim/ayarlar", icon: Settings, label: "Ayarlar" },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen flex bg-slate-50">
      <button onClick={() => setOpen(!open)} className="lg:hidden fixed top-3 right-3 z-50 bg-slate-900 text-white rounded-lg p-2" data-testid="admin-menu-toggle"><Menu className="w-5 h-5" /></button>
      {open && <div className="lg:hidden fixed inset-0 bg-black/40 z-30" onClick={() => setOpen(false)} />}
      <aside className={`w-60 bg-slate-900 text-white flex flex-col fixed h-screen z-40 transition-transform lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="p-5 flex items-center gap-2.5 border-b border-slate-800">
          <div className="w-8 h-8 rounded-lg bg-teal-500 flex items-center justify-center">
            <FlaskConical className="w-4 h-4" />
          </div>
          <div className="font-head font-bold">Yönetim</div>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto" onClick={() => setOpen(false)}>
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-teal-600 text-white" : "text-slate-300 hover:bg-white/10"}`}>
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-800 space-y-1">
          <Button variant="ghost" className="w-full justify-start text-slate-300 hover:bg-white/10" onClick={() => navigate("/")}>
            Siteye Dön
          </Button>
          <Button variant="ghost" className="w-full justify-start text-slate-300 hover:bg-white/10"
            onClick={() => { logout(); navigate("/"); }} data-testid="admin-logout">
            <LogOut className="w-4 h-4 mr-2" /> Çıkış
          </Button>
        </div>
      </aside>
      <div className="flex-1 min-w-0 lg:ml-60 p-4 pt-16 lg:p-8"><Outlet /></div>
    </div>
  );
}
